import CharacterList from "./CharacterList";

export default CharacterList;
